import React, { Component } from 'react';
import Formsy from 'formsy-react';
import { FloatingLabelInput as Input } from '../../Elements';
import { DthcActions } from '../../Modules';
import PropTypes from 'prop-types';

class NewSong extends Component {
  static propTypes = {
    addToPlaylist: PropTypes.func.isRequired,
    newSong: PropTypes.object.isRequired,
    newSongFieldChange: PropTypes.func.isRequired,
    closeNewSongForm: PropTypes.func.isRequired
  };

  render() {
    const {
      addToPlaylist,
      closeNewSongForm,
      newSong,
      newSongFieldChange
    } = this.props;

    return (
      <Formsy.Form>
        <Input
          autoFocus
          name='name'
          label='Song Name'
          value={newSong.name || ''}
          onChange={newSongFieldChange}
          required
          validationError='Song name is required'
        />
        <Input
          name='artist'
          label='Artist'
          value={newSong.artist || ''}
          onChange={newSongFieldChange}
        />
        <DthcActions
          save={e => addToPlaylist(e, newSong, null, closeNewSongForm)}
          reset={closeNewSongForm}
        />
      </Formsy.Form>
    );
  }
}

export default NewSong;



// WEBPACK FOOTER //
// ./webpack/components/Playlist/Song/NewSong.js